import sessionMixin from 'session-plugin/lib/sessionMixin'

const SessionPlugin = {
  defaultOps: {
    systemMode: {},
    roleAccess: {}
  },
  install (Vue, options) {
    Vue.prototype.session = {}
    Vue.mixin(sessionMixin)
    Vue.prototype.$store = function () {
      this.$store
    }
  }
}

export default SessionPlugin
